import React from 'react';
import "./Homepage.css"

const Homepage = () => {
  return <div className="homepage">
      Shoe Shop
  </div>;
};

export default Homepage;
